import request from '@/utils/request'
import URL from '@/api/urlTranslator'
// 根据条件查询客户
export function queryQuotationClient(data) {
  return request({
    url: URL.crm.queryQuotationClient,
    method: 'post',
    data
  })
}

// 我的客户、本组客户、客户公海 列表查询
export function queryQuotationClientPageable(data) {
  return request({
    url: URL.crm.queryQuotationClientPageable,
    method: 'post',
    data
  })
}

// 事件管理 列表查询
export function queryQuotationClientEventPageableFast(data) {
  return request({
    url: URL.crm.queryQuotationClientEventPageableFast,
    method: 'post',
    data
  })
}

// 我的客户、本组客户 左边查询
export function updateCountData(data) {
  return request({
    url: URL.crm.updateCountData,
    method: 'post',
    data
  })
}

// 释放
export function releaseQuotationClients(data) {
  return request({
    url: URL.crm.releaseQuotationClients,
    method: 'post',
    data
  })
}

// 审核（同意）
export function agreeQuotationClients(data) {
  return request({
    url: URL.crm.agreeQuotationClients,
    method: 'post',
    data
  })
}

// 拒绝（审核）
export function refuseQuotationClients(data) {
  return request({
    url: URL.crm.refuseQuotationClients,
    method: 'post',
    data
  })
}

// 根据选中的客户 查询合作伙伴中英文名称，并返回匹配的记录
export function getMatchCompanyByName(data) {
  return request({
    url: URL.crm.getMatchCompanyByName,
    method: 'post',
    data
  })
}

// 签单-关联合作伙伴
export function signQuotationClientJoinCompany(data) {
  return request({
    url: URL.crm.signQuotationClientJoinCompany,
    method: 'post',
    data
  })
}

// 批量签单
export function signQuotationClientList(clientUuids) {
  return request({
    url: URL.crm.signQuotationClientList,
    method: 'post',
    data: clientUuids
  })
}

// 加载QuotationClient的关联实体信息
export function loadQuotationClientRelated(params) {
  return request({
    url: URL.crm.loadQuotationClientRelated,
    method: 'get',
    params
  })
}

// 保存校验
export function validateQuotationClient(data) {
  return request({
    url: URL.crm.validateQuotationClient,
    method: 'post',
    data
  })
}

// 保存
export function saveQuotationClient(data) {
  return request({
    url: URL.crm.saveQuotationClient,
    method: 'post',
    data
  })
}

// 分配
export function assignQuotationClients(data) {
  return request({
    url: URL.crm.assignQuotationClients,
    method: 'post',
    data
  })
}

// 修改客户部分字段【延长期限】
export function updateQuotationClientField(data) {
  return request({
    url: URL.crm.updateQuotationClientField,
    method: 'post',
    data
  })
}

// 分配给我
export function assignQuotationClientsAndApprove(data) {
  return request({
    url: URL.crm.assignQuotationClientsAndApprove,
    method: 'post',
    data
  })
}

// 事件管理保存
export function saveQuotationClientEvent(data) {
  return request({
    url: URL.crm.saveQuotationClientEvent,
    method: 'post',
    data
  })
}
// 报价客户管理-获取客户名称
export function querySimilarClients(params) {
  return request({
    url: URL.crm.querySimilarClients,
    method: 'post',
    params
  })
}
// 报价客户管理-判断客户名称是否已存在
export function isClientExist(params) {
  return request({
    url: URL.crm.isClientExist,
    method: 'post',
    params
  })
}
